import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { FaUpload } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addCSV, addOrder } from "../../Services/orderService";

const AddOrders = () => {


    const companyId = useSelector(state => state.auth.companyId);
    const companyPin = useSelector(state => state.auth.companyPin);

    const [formData, setFormData] = useState({
        company_id: companyId,
        company_pin: companyPin,
        customerName: "",
        phoneNumber: "",
        address: "",
        city: "",
        articleName: "",
        quantity: 1,
        amount: "",
        cnic: "",
        bookingAgent: "",
        remark: "",
        is_confirmed: "",
        product: ""
    });

    /* 🔹 INPUT CHANGE */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    /* 🔹 SUBMIT SINGLE ORDER */
    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await addOrder(formData);

        if (res?.status === "success") {
            toast.success("Order added successfully");

            setFormData({
                company_id: companyId,
                company_pin: companyPin,
                customerName: "",
                phoneNumber: "",
                address: "",
                city: "",
                articleName: "",
                quantity: 1,
                amount: "",
                cnic: "",
                bookingAgent: "",
                remark: "",
                is_confirmed: ""
            });
        } else {
            toast.error(res?.message || "Something went wrong");
        }
    };

    /* 🔹 CSV / EXCEL UPLOAD */
    const handleCSVUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        // 👇 yeh add karo
        formData.append("company_id", companyId);
        formData.append("company_pin", companyPin);

        const res = await addCSV(formData);

        if (res?.status === "success") {
            toast.success("CSV uploaded successfully");
            e.target.value = "";
        } else {
            toast.error(res?.message || "Upload failed");
        }
    };

    return (
        <div className="container">
            <div className="row mb-3 align-items-center">
                <div className="col-auto">
                    <Link to={"/portal/confirm-orders"} className="oms-icon-btn print"
                    >
                        <IoMdArrowRoundBack />

                        {/* 🖨 */}
                    </Link >
                </div>
                <div className="col ">




                    <h4 className="fw-semibold mb-0">Add Order</h4>
                </div>

                <div className="col-auto d-none">
                    <Button variant="success" as="label">
                        <FaUpload size={16} className="me-2" />
                        Upload CSV
                        <input
                            type="file"
                            hidden
                            accept=".xlsx,.xls,.csv"
                            onChange={handleCSVUpload}
                        />
                    </Button>
                </div>
            </div>

            <Form className="row" onSubmit={handleSubmit}>
                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Name *</Form.Label>
                    <input
                        className="oms-form-input"
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                        required
                        placeholder="Enter Name"
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Phone Number *</Form.Label>
                    <input
                        className="oms-form-input"
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Address *</Form.Label>
                    <input
                        className="oms-form-input"
                        placeholder="Enter Address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">City *</Form.Label>
                    <input
                        className="oms-form-input"
                        placeholder="Enter City"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Article Name *</Form.Label>
                    <input
                        className="oms-form-input"
                        placeholder="Enter Article Name"
                        name="articleName"
                        value={formData.articleName}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Product *</Form.Label>
                    <input
                        className="oms-form-input"
                        placeholder="Enter Product"
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Quantity *</Form.Label>
                    <input

                        placeholder="Enter Quantity"
                        className="oms-form-input"
                        type="number"
                        min="1"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Amount *</Form.Label>
                    <input

                        className="oms-form-input"
                        placeholder="Enter Amount"
                        type="number"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">CNIC</Form.Label>
                    <input

                        className="oms-form-input"
                        placeholder="Enter CNIC"
                        name="cnic"
                        value={formData.cnic}
                        onChange={handleChange}
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label className="oms-label-dark">Booking Agent</Form.Label>
                    <input

                        className="oms-form-input"
                        placeholder="Enter Booking Agent"
                        name="bookingAgent"
                        value={formData.bookingAgent}
                        onChange={handleChange}
                    />
                </Form.Group>


                <div className="text-end">
                    <button className="oms-btn oms-btn-primary" type="submit">
                        Save Order
                    </button>
                </div>
            </Form>
        </div>
    );
};

export default AddOrders;
